export const ALL_PLAYLIST_REQUEST = "PLAYLIST_REQUEST"
export const ALL_PLAYLIST_SUCCESS = "ALL_PLAYLIST_SUCCESS"
export const ADD_TO_PLAYLIST = "ADD_TO_PLAYLIST"
export const CREATE_PLAYLIST = "CREATE_PLAYLIST"
export const DELETE_PLAYLIST = "DELETE_PLAYLIST"
export const PLAYLIST_SUCCESS = "PLAYLIST_SUCCESS"
export const PLAYLIST_REQUEST = "PLAYLIST_REQUEST"
export const DELETE_FROM_PLAYLIST = "DELETE_FROM_PLAYLIST"
